import React from 'react';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import FormField from '../../../core/components/FormField.tsx';
import StringField from '../../../core/components/Fields/StringField.tsx';
import BooleanField from '../../../core/components/Fields/BooleanField.tsx';

export const SSO_CONFIG_FORM_DEFAULT_VALUES = {
    isRequired: false,
    providerName: '',
    domain: '',
    allowSelfRegistration: false,
    tenantId: '',
    clientId: '',
    clientSecret: '',
};

interface SsoConfigFieldsProps {
    control: Control<any>;
    errors: FieldErrors;
}

const SsoConfigFields = ({ control, errors }: SsoConfigFieldsProps) => {
    const { t } = useTranslation('customer');

    return (
        <>
            <Controller
                name="isRequired"
                control={control}
                render={({ field }) => (
                    <FormField
                        label={t('sso.form.isRequired')}
                        error={errors.isRequired}
                        helpText={t('sso.form.isRequiredHelpText')}
                    >
                        <BooleanField {...field} value={field.value ? 'true' : ''} />
                    </FormField>
                )}
            />

            <Controller
                name="providerName"
                control={control}
                render={({ field }) => (
                    <FormField label={t('sso.form.providerName')} error={errors.providerName}>
                        <StringField {...field} />
                    </FormField>
                )}
            />

            <Controller
                name="domain"
                control={control}
                render={({ field }) => (
                    <FormField label={t('sso.form.domain')} error={errors.domain}>
                        <StringField {...field} />
                    </FormField>
                )}
            />

            <Controller
                name="allowSelfRegistration"
                control={control}
                render={({ field }) => (
                    <FormField label={t('sso.form.allowSelfRegistration')} error={errors.allowSelfRegistration}>
                        <BooleanField {...field} value={field.value ? 'true' : ''} />
                    </FormField>
                )}
            />

            <Controller
                name="tenantId"
                control={control}
                render={({ field }) => (
                    <FormField label={t('sso.form.tenantId')} error={errors.tenantId}>
                        <StringField {...field} />
                    </FormField>
                )}
            />

            <Controller
                name="clientId"
                control={control}
                render={({ field }) => (
                    <FormField label={t('sso.form.clientId')} error={errors.clientId}>
                        <StringField {...field} />
                    </FormField>
                )}
            />

            <Controller
                name="clientSecret"
                control={control}
                render={({ field }) => (
                    <FormField label={t('sso.form.clientSecret')} helpText={t('sso.form.clientSecretHelpText')}>
                        <StringField id="clientSecret" placeholder={t('sso.form.clientSecretPlaceholder')} {...field} />
                    </FormField>
                )}
            />
        </>
    );
};

export default SsoConfigFields;
